/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EMonographPresentationStatus } from "../types/EMonographPresentationStatus.ts";

/**
 * @description 0 = Uninformed | 1 = PendingAction | 2 = Confirmed | 3 = AwaitingStudentAcceptance | 4 = Approved | 5 = Failed | 6 = Cancelled | 7 = TemporarilyReproved |
 */
export const eMonographPresentationStatusSchema = z
  .union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
  ])
  .describe(
    "0 = Uninformed | 1 = PendingAction | 2 = Confirmed | 3 = AwaitingStudentAcceptance | 4 = Approved | 5 = Failed | 6 = Cancelled | 7 = TemporarilyReproved | ",
  ) as unknown as ToZod<EMonographPresentationStatus>;
